/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CarFinancialFundingType {
    COMPANY_CAR = 'COMPANY_CAR',
    FREE_PARKING = 'FREE_PARKING',
    OTHER = 'OTHER',
}
